export default __webpack_public_path__ + "static/media/2040.43338d14.png";